import React, { ReactElement, useState } from 'react'
import { getApiLog, clearApiLog, MAX_EVENTS, tabLoadedAt, formatEvent, relativeLoadTime } from '../helpers/apiLog'

const ApiLog = (): ReactElement => {
    const [tick, setTick] = useState(0)
    void tick
    const events = getApiLog()
    const isFull = events.length >= MAX_EVENTS
    const copyLog = () => void navigator.clipboard?.writeText(JSON.stringify(events))
    const clear = () => {
        clearApiLog()
        setTick(n => n + 1)
    }
    return <div className="thumbnail thumbnail-static">
        <h3>API log</h3>
        <div className="tip">
            This tab loaded {relativeLoadTime()}, at {new Date(tabLoadedAt).toLocaleTimeString()}.
        </div>
        <div style={ { marginTop: '0.5em' } }>
            <button onClick={ copyLog }>Copy log (JSON)</button>
            {' '}
            <button onClick={ clear }>Clear</button>
        </div>
        <details style={ { marginTop: '0.5em' } }>
            <summary>
                {isFull
                    ? `${MAX_EVENTS}/${MAX_EVENTS} events (recording stopped)`
                    : `${events.length}/${MAX_EVENTS} events`}
            </summary>
            <pre style={ { maxHeight: '20em', overflow: 'auto', fontSize: '0.75em', whiteSpace: 'pre' } }>
                {events.map(formatEvent).join('\n')}
            </pre>
        </details>
    </div>
}

export default ApiLog
